import {
  QuestionType,
  SessionCreateMutation,
  SessionEndMutation,
  SessionNextRoundMutation,
  SessionSetSharingMutation,
  UserGetMeQuery
} from '@/API';
import { userGetMe } from '@/graphql/queries';
import {
  sessionCreate,
  sessionEnd,
  sessionNextRound,
  sessionSetSharing,
  sessionSetEnding
} from '@/graphql/mutations';
import { generateClient, GraphQLQuery } from 'aws-amplify/api';

const client = generateClient();

export async function createSession({
  promptIds,
  organizationId
}: {
  promptIds: string[];
  organizationId?: string;
}) {
  let resolvedOrganizationId = organizationId;

  if (!resolvedOrganizationId) {
    const me = await client.graphql<GraphQLQuery<UserGetMeQuery>>({ query: userGetMe });
    resolvedOrganizationId = me.data?.userGetMe?.organizationId ?? undefined;
  }

  const session = await client.graphql<GraphQLQuery<SessionCreateMutation>>({
    query: sessionCreate,
    variables: {
      input: {
        promptIds,
        questionType:
          Object.keys(QuestionType)[Math.floor(Math.random() * Object.keys(QuestionType).length)],
        organizationId: resolvedOrganizationId
      }
    }
  });

  return session.data?.sessionCreate;
}

export async function nextRound({ id }: { id: string }) {
  const session = await client.graphql<GraphQLQuery<SessionNextRoundMutation>>({
    query: sessionNextRound,
    variables: {
      id
    }
  });

  return session.data?.sessionNextRound;
}

// Set the session to Ending (used when host clicks End Game)
export async function setEnding({ id }: { id: string }) {
  await client.graphql<GraphQLQuery<SessionEndMutation>>({
    query: sessionSetEnding,
    variables: { id }
  });
  return null;
}

// Finalize the session (used by the ending screen)
export async function endSession({ id }: { id: string }) {
  const session = await client.graphql<GraphQLQuery<SessionEndMutation>>({
    query: sessionEnd,
    variables: { id }
  });
  return session.data?.sessionEnd;
}

export async function setSharing({ id, playerId }: { id: string; playerId: string }) {
  const session = await client.graphql<GraphQLQuery<SessionSetSharingMutation>>({
    query: sessionSetSharing,
    variables: {
      id,
      playerId
    }
  });

  return session.data?.sessionSetSharing;
}
